import PropTypes from "prop-types";
import dayjs from "dayjs";
import Grid from "@mui/material/Unstable_Grid2";
import { Typography, Link } from "@mui/material";

import { initLocalization } from "../../../utils/helpers";
import { viewMappingDetailsMetadataStrings } from "./locale";

import { MAPPING_KEYS_DATE_FORMAT } from "../../../constants";

export const ViewMappingDetailsMetadata = ({ item }) => {
  initLocalization(viewMappingDetailsMetadataStrings);

  return (
    <Grid
      container
      flexDirection="column"
      flex="2"
      justifyContent="center"
      gap="0.625rem"
      padding="2rem"
    >
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.id}
      </Typography>
      <Typography>{item.creativeDetails.creativeId}</Typography>
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.type}
      </Typography>
      <Typography>{item.creativeDetails.creativeType}</Typography>
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.date}
      </Typography>
      {item.creativeDetails.firstOccurrence
        ? dayjs(item.creativeDetails.firstOccurrence).format(
            MAPPING_KEYS_DATE_FORMAT,
          )
        : ""}
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.campaign}
      </Typography>
      <Typography>{item.campaignTitle}</Typography>
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.domain}
      </Typography>
      <Typography>
        <Link href={item.advertiserDomain} target="_blank">
          {item.advertiserDomain}
        </Link>
      </Typography>
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.site}
      </Typography>
      <Typography>{item.advertiser}</Typography>
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.link}
      </Typography>
      <Typography>
        <Link href={item.campaignUrl} target="_blank">
          {viewMappingDetailsMetadataStrings.link}
        </Link>
      </Typography>
    </Grid>
  );
};

ViewMappingDetailsMetadata.propTypes = {
  item: PropTypes.object.isRequired,
};
